/** TB02115_DATA em dd/MM/yyyy [HH:mm] sem deslocar fuso (UTC em Date / partes literais). */
export function formatReincidenciaDataAbertura(value, withTime = true) {
  if (value == null || value === '') return '—';
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const dd = String(value.getUTCDate()).padStart(2, '0');
    const mm = String(value.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = value.getUTCFullYear();
    const base = `${dd}/${mm}/${yyyy}`;
    if (!withTime) return base;
    const hh = String(value.getUTCHours()).padStart(2, '0');
    const min = String(value.getUTCMinutes()).padStart(2, '0');
    return `${base} ${hh}:${min}`;
  }
  const s = String(value).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (iso) {
    const base = `${iso[3]}/${iso[2]}/${iso[1]}`;
    if (iso[4] != null && iso[5] != null && withTime) return `${base} ${iso[4]}:${iso[5]}`;
    return base;
  }
  const dmySlash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (dmySlash) {
    const base = `${dmySlash[1].padStart(2, '0')}/${dmySlash[2].padStart(2, '0')}/${dmySlash[3]}`;
    if (!withTime) return base;
    const time = s.match(/(\d{2}):(\d{2})/);
    return time ? `${base} ${time[1]}:${time[2]}` : base;
  }
  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) {
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = d.getUTCFullYear();
    const base = `${dd}/${mm}/${yyyy}`;
    if (!withTime) return base;
    const hh = String(d.getUTCHours()).padStart(2, '0');
    const min = String(d.getUTCMinutes()).padStart(2, '0');
    return `${base} ${hh}:${min}`;
  }
  return '—';
}

/** Ordena por Indice (asc): OS atual / mais recente primeiro, mais antigas abaixo. */
export function sortReincidenciaHistoricoItems(items, limit = 8) {
  if (!Array.isArray(items)) return [];
  return items
    .slice()
    .sort((a, b) => Number(a.Indice || 0) - Number(b.Indice || 0))
    .slice(0, limit);
}

/** Rótulo da OS no stepper: atual usa OS_Atual; anteriores usam OS_Anterior quando preenchido. */
export function getReincidenciaStepOsLabel(item, currentOrderId) {
  const currentId = String(currentOrderId ?? '').trim();
  const osAtual = String(item?.OS_Atual ?? '').trim();
  const osAnterior = String(item?.OS_Anterior ?? '').trim();
  if (osAtual && currentId && osAtual === currentId) return osAtual;
  return osAnterior || osAtual || '—';
}
